import React from 'react';
import HeaderTwo from '../../common/header/HeaderTwo';
import BannerOne from '../../components/section-components/BannerOne';
import WelcomeTwo from '../../components/section-components/WelcomeTwo';
import AwardTwo from '../../components/section-components/AwardTwo';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasTwo from '../../components/section-components/PracticeAreasTwo';
import OurAttorneysTwo from '../../components/section-components/OurAttorneysTwo';
import Counter from '../../components/section-components/Counter';
import BlogTwo from '../../components/section-components/BlogTwo';
import TestimonialTwo from '../../components/section-components/TestimonialTwo';
import FooterTwo from '../../common/footer/FooterTwo';

const HomeTwo = () => {
    return (
        <>
        <HeaderTwo />

        <BannerOne />
        
        <WelcomeTwo />
        
        <AwardTwo /> 
        
        <Experiences />
        
        <PracticeAreasTwo />
        
        <OurAttorneysTwo />
        
        <Counter />
        
        <BlogTwo />
        
        <TestimonialTwo />

        <FooterTwo />
        </>
        )
}
    
export default HomeTwo;